import { render } from "./uiWaveAnimation.vue?vue&type=template&id=cd49517c"
import script from "./uiWaveAnimation.vue?vue&type=script&lang=js"
export * from "./uiWaveAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__